import { Route, Routes as ModuleRoutes } from '@direct-frontend/modules-router';
import { RumWrapper } from '@adv-frontend/yastore-modules/lib';
import { Checkout } from '@/pages/checkout';
import { NotFound } from '@/pages/notFound';

export const Routes = () => (
    <ModuleRoutes>
        <Route element={<RumWrapper />}>
            <Route path="/orders/:storeSlug/:orderId" element={<Checkout type="order" />} />
            <Route path="/digital-orders/:storeSlug/:orderId" element={<Checkout type="digital-order" />} />
            <Route path="*" element={<NotFound />} />
        </Route>
    </ModuleRoutes>
);
